import { memo } from '@morphic-ts/common/es6/utils';
import { fold, monoidAll } from 'fp-ts/Monoid';
import { EqType, EqURI } from '../hkt';
import { eqApplyConfig } from './../config';
/**
 *  @since 0.0.1
 */
export const eqIntersectionInterpreter = memo(() => ({
    _F: EqURI,
    intersection: (...types) => (_name, config) => (env) => {
        const equals = types.map(getEq => getEq(env).eq);
        return new EqType(eqApplyConfig(config)({
            equals: (a, b) => fold(monoidAll)(equals.map(eq => eq.equals(a, b))) // TODO: optimize
        }, env, {
            equals
        }));
    }
}));
